/**
 * External Demo access (partner test drives of Origin).
 *
 * A user doc with `externalDemo: true` (set from UserAdminControls) is a
 * non-employee demo account: it may ONLY use the Origin CRM. Route guarding
 * (AppRouter's ProtectedRoute), nav rendering (Sidebar/DrawerBar/Navbar) and
 * feature gates (featureAccess.js) all read these helpers so the rules live
 * in exactly one place — same pattern as workspaceAccess.js.
 *
 * Server-side counterparts (outbound email/SMS, campaign enrollment, and SSO
 * satellite-app claims are all denied for demo accounts) live in
 * functions/CRM/email/sendEmailWithSignature.js, functions/CRM/dialpad/sendSMS.js,
 * functions/CRM/automations/{subscribeToCampaign,contextHydrator,handlers/*}.js
 * and functions/Auth/getSsoToken.js.
 *
 * IMPORTANT: every check is strictly opt-in (`externalDemo === true`), so
 * existing users — where the field does not exist — are completely unaffected.
 */

export function isExternalDemoUser(currentUser) {
  return currentUser?.externalDemo === true;
}

/**
 * Paths an external demo user may visit. Everything else redirects to /crm.
 *
 * - /crm/* : Origin itself. Company-data pages inside it stay blocked by
 *   their own guards (SuperAdminRoute for /crm/admin, canAccessNewFeatures
 *   for leaderboard/mortgage-monitor, workspace allowlist).
 * - /tasks : the CRM Tasks page linked from the Origin nav (owner-scoped).
 * - /profile (exact) : the user's own profile. /profile/:id (other users'
 *   profiles) intentionally does NOT match.
 */
export function isDemoAllowedPath(pathname) {
  if (!pathname) return false;
  if (pathname === '/crm' || pathname.startsWith('/crm/')) return true;
  if (pathname === '/tasks') return true;
  if (pathname === '/profile') return true;
  return false;
}
